// Lift notes (Kenny, 2026-11-03): many dated notes per lift, newest first, shown every time the lift
// comes up. Pure, no DB.

const newestFirst = (a, b) => ((b.date || '') < (a.date || '') ? -1 : (b.date || '') > (a.date || '') ? 1 : (b.created_at || '') < (a.created_at || '') ? -1 : 1);

// { exercise_id: [note, ...] }, newest first. Notes hidden under the old one-note-per-lift rule are skipped.
export function notesByLift(rows) {
  const out = {};
  for (const n of rows || []) {
    if (n.dismissed_at) continue;
    (out[n.exercise_id] ||= []).push(n);
  }
  for (const k of Object.keys(out)) out[k].sort(newestFirst);
  return out;
}

// A day's past workout notes (the free-text note on the whole workout), newest first.
export function workoutNotesFor(sessions, dayId) {
  return (sessions || []).filter((s) => s.program_day_id === dayId && (s.notes || '').trim())
    .sort((a, b) => (b.date < a.date ? -1 : b.date > a.date ? 1 : 0));
}

export function noteDate(iso) {
  if (!iso) return '';
  return new Date(`${iso.slice(0, 10)}T00:00:00`).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: iso.slice(0, 4) === String(new Date().getFullYear()) ? undefined : 'numeric' });
}
